<template>
  <div class="parameters">
    <div class="d-flex justify-content-between parameters__wrapper">
      <ul class="parameters__list">
        <li class="parameters__element">
          <span class="parameters__name">Concentration:</span>
          <span class="parameters__value">{{ params.concentration }}</span>
        </li>
        <li class="parameters__element">
          <span class="parameters__name">Volume:</span>
          <span class="parameters__value">{{ params.volume }}</span>
        </li>
        <li class="parameters__element">
          <span class="parameters__name">Solvent:</span>
          <span class="parameters__value">{{ params.solvent }}</span>
        </li>
      </ul>
      <ul class="parameters__list">
        <li class="parameters__element">
          <span class="parameters__name">Vessel:</span>
          <span class="parameters__value">{{ params.vessel }}</span>
        </li>
        <li class="parameters__element">
          <span class="parameters__name">Temperature:</span>
          <span class="parameters__value">{{ params.temperature }}</span>
        </li>
        <li class="parameters__element">
          <span class="parameters__name">I-M Time:</span>
          <span class="parameters__value">{{ params.i_m_time }}</span>
        </li>
      </ul>
      <ul class="parameters__list">
        <li class="parameters__element">
          <span class="parameters__name">Additional M Time:</span>
          <span class="parameters__value">{{ params.additional_m_time }}</span>
        </li>
        <li class="parameters__element">
          <span class="parameters__name">Termination Time:</span>
          <span class="parameters__value">{{ params.termination_time }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import game from '@/api/v1/game';

export default {
  data() {
    return {
      params: [],
    };
  },
  methods: {
    getParams() {
      const succ = (response) => {
        this.params = response.data.experiments_parameters;
      };
      game.index(succ);
    },
  },
  created() {
    this.getParams();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';

.parameters {
  background-color: $color--white-1;
  padding: 30px 0;
  margin: 50px 0;
  &__wrapper{
    max-width: 680px;
    margin: 0 auto;
  }
  &__name {
    color: $color--gray-3;
    font-size: 16px;
    line-height: 40px;
    font-weight: 800;
  }
  &__element {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__list {
    width: 30%;
  }
  &__value {
    color: $color--gray-3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Game/BuldingBlocks/Heading.vue